import styled from 'styled-components';
import {flexColumnContainerMixin, flexRowReverseContainerMixin} from '../../../../themes/architecture/css-helpers/flex';
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const ButtonsWrapperDefaultBox = styled.div<{buttonsOnSeparateLines?: boolean; margin?: string}>`
    width: 100%;
    margin: ${({margin}) => margin ? margin : "5rem auto 0" };
    ${({buttonsOnSeparateLines}) => buttonsOnSeparateLines ? flexColumnContainerMixin : flexRowReverseContainerMixin }

    ${CssRule.For.mobile.landscape.build()} & {
      margin: 1rem auto 0;
      width: 80%;
    }
`;
